<template>
  <div class="animated fadeIn page-shell">
    <div class="page-main">
      <header-padrao class="mb-2" icon="fa fa-exchange" titulo="CADASTRO DE AJUSTE DE ESTOQUE">
        <template #subtitulo>
          <div class="d-flex align-items-center flex-wrap">
            <span class="mr-2">
              <i class="fa fa-key mr-1 text-info"></i>
              ID: <strong class="text-white">{{registro.CONTADOR || 'Novo'}}</strong>
            </span>
            <span v-if="registro.DESCRICAO" class="mx-2">•</span>
            <span v-if="registro.DESCRICAO" class="mr-2">
              {{registro.DESCRICAO.substring(0,30)}}
            </span>
          </div>
        </template>

        <template #acoes>
          <b-button variant="link" class="btn-glass btn-glass-success px-4 font-weight-bold" @click.stop.prevent="gravar()">
            <i class="fa fa-save mr-1"></i> GRAVAR
          </b-button>

          <b-button variant="light" pill class="ml-2 font-weight-bold shadow-sm px-4" @click.stop.prevent="voltar()">
            <i class="fa fa-arrow-left mr-1"></i> Voltar
          </b-button>
        </template>
      </header-padrao>

      <b-row class="px-2">
        <b-col sm="12">
          <!-- Dados do Produto -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-primary text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-cube"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Produto</h6>
                  <small class="text-muted">Selecione o produto para ajuste de estoque</small>
                </div>
              </div>
            </template>

            <b-row class="mb-3">
              <b-col sm="8">
                <label class="modal-label-premium">Produto *</label>
                <produto-pesquisa
                    @retornaId="onProdutoSelected"
                    :idInicial="registro.COD_PRO"
                    place="Selecione o produto..."
                    labelBotao=""
                    :classeRequired="!registro.COD_PRO"
                    :desabilitarInput="!!registro.CONTADOR"
                    ref="produtoPesquisa">
                </produto-pesquisa>
              </b-col>
              <b-col sm="4">
                <label class="modal-label-premium">Centro de Estoque *</label>
                <centro-estoque-drop-down
                    v-model="registro.COD_CENTRO"
                    :state="registro.COD_CENTRO ? null : false"
                    :disabled="!!registro.CONTADOR"
                    placeholder="Selecione o centro..."
                    :input-class="['rounded-pill', { 'is-invalid': !registro.COD_CENTRO }]"
                    ref="centroEstoquePesquisa">
                </centro-estoque-drop-down>
              </b-col>
            </b-row>
            
            <b-row v-if="estoqueProduto" class="mb-3">
              <b-col sm="12">
                <b-alert show variant="info" class="mb-0">
                  <div class="d-flex justify-content-between">
                    <div>
                      <strong>Estoque Atual:</strong> {{ formatarNumero(estoqueProduto.QUANT) }} 
                      <span class="ml-3"><strong>Volumes:</strong> {{ formatarNumero(estoqueProduto.QUANT_PECAS) }}</span>
                    </div>
                  </div>
                </b-alert>
              </b-col>
            </b-row>
            
            <!-- Alerta sobre execução do ajuste -->
            <b-row v-if="!registro.CONTADOR" class="mb-3">
              <b-col sm="12">
                <b-alert show variant="warning" class="mb-0">
                  <i class="fa fa-exclamation-triangle mr-2"></i>
                  <strong>Atenção:</strong> Este ajuste de estoque será processado e aplicado somente à meia-noite (00:00h).
                </b-alert>
              </b-col>
            </b-row>
          </b-card>

          <!-- Ajuste de Quantidade -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-success text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-balance-scale"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Ajuste de Estoque</h6>
                  <small class="text-muted">Informe os novos valores após o ajuste</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col md="6">
                <div class="card bg-light border-0 p-3 mb-3">
                  <h6 class="font-weight-bold text-muted mb-3">Quantidade</h6>
                  <b-row class="mb-2">
                    <b-col cols="6">
                      <label class="small font-weight-bold">Quantidade Antes</label>
                      <money 
                        v-model="registro.QUANT" 
                        v-bind="moneyConfig" 
                        disabled
                        class="form-control text-right bg-white campo-desabilitado rounded-pill">
                      </money>
                    </b-col>
                    <b-col cols="6">
                      <label class="small font-weight-bold">Quantidade Depois *</label>
                      <money 
                        v-model="registro.QUANT_AJUSTE" 
                        v-bind="moneyConfig" 
                        class="form-control text-right rounded-pill"
                        :class="{'is-invalid': !registro.QUANT_AJUSTE && registro.QUANT_AJUSTE !== 0}"
                        ref="edQuantAjuste">
                      </money>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <label class="small font-weight-bold">Diferença</label>
                      <b-form-input 
                        :value="formatarNumero(registro.DIFE_QUANT)" 
                        disabled
                        class="text-right bg-white campo-desabilitado rounded-pill"
                        :class="{'text-success': registro.DIFE_QUANT > 0, 'text-danger': registro.DIFE_QUANT < 0}">
                      </b-form-input>
                    </b-col>
                  </b-row>
                </div>
              </b-col>

              <b-col md="6">
                <div class="card bg-light border-0 p-3 mb-3">
                  <h6 class="font-weight-bold text-muted mb-3">Volumes (Peças)</h6>
                  <b-row class="mb-2">
                    <b-col cols="6">
                      <label class="small font-weight-bold">Volumes Antes</label>
                      <money 
                        v-model="registro.QUANT_PECAS" 
                        v-bind="moneyConfig" 
                        disabled
                        class="form-control text-right bg-white campo-desabilitado rounded-pill">
                      </money>
                    </b-col>
                    <b-col cols="6">
                      <label class="small font-weight-bold">Volumes Depois *</label>
                      <money 
                        v-model="registro.QUANT_PECAS_AJUSTE" 
                        v-bind="moneyConfig" 
                        class="form-control text-right rounded-pill"
                        :class="{'is-invalid': !registro.QUANT_PECAS_AJUSTE && registro.QUANT_PECAS_AJUSTE !== 0}">
                      </money>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col cols="12">
                      <label class="small font-weight-bold">Diferença</label>
                      <b-form-input 
                        :value="formatarNumero(registro.DIFE_PECAS)" 
                        disabled
                        class="text-right bg-white campo-desabilitado rounded-pill"
                        :class="{'text-success': registro.DIFE_PECAS > 0, 'text-danger': registro.DIFE_PECAS < 0}">
                      </b-form-input>
                    </b-col>
                  </b-row>
                </div>
              </b-col>
            </b-row>
          </b-card>

          <!-- Observações -->
          <b-card class="border-0 shadow-sm mb-4" body-class="p-4" :bg-variant="isDark ? 'gray-700' : 'white'">
            <template #header>
              <div class="d-flex align-items-center">
                <div class="bg-warning text-white rounded-circle p-2 mr-3 d-flex align-items-center justify-content-center" style="width: 40px; height: 40px;">
                  <i class="fa fa-comment"></i>
                </div>
                <div>
                  <h6 class="mb-0 font-weight-bold">Observações</h6>
                  <small class="text-muted">Informações adicionais sobre o ajuste</small>
                </div>
              </div>
            </template>

            <b-row>
              <b-col sm="8" class="mb-3">
                <label class="modal-label-premium">Observação</label>
                <b-form-input type="text" v-model="registro.MEMO1" maxlength="60" class="rounded-pill shadow-xs"></b-form-input>
              </b-col>
              <b-col sm="4" class="mb-3">
                <label class="modal-label-premium">Usuário</label>
                <b-form-input 
                  type="text" 
                  :value="registro.USUARIO || (registro.CONTADOR ? '' : (getUsuarioLogado() || 'Sistema'))" 
                  disabled 
                  class="rounded-pill shadow-xs bg-light campo-desabilitado">
                </b-form-input>
              </b-col>
            </b-row>
          </b-card>

        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import HeaderPadrao from '@/components/Cec/HeaderPadrao.vue'
import ProdutoPesquisa from '@/views/pesquisa/ProdutoPesquisa.vue'
import CentroEstoqueDropDown from '@/views/componentes/dropdown/CentroEstoqueDropDown.vue'
import { Money } from 'v-money'

export default {
  components: {
    HeaderPadrao,
    ProdutoPesquisa,
    CentroEstoqueDropDown,
    Money
  },
  data() {
    return {
      estoqueProduto: null,
      registro: {
        CONTADOR: null,
        COD_PRO: null,
        DESCRICAO: '',
        QUANT: 0,
        QUANT_PECAS: 0,
        QUANT_AJUSTE: 0,
        QUANT_PECAS_AJUSTE: 0,
        USUARIO: '',
        DATA: null,
        MEMO1: '',
        MEMO2: '',
        MEMO3: '',
        DIFE_PECAS: 0,
        DIFE_QUANT: 0,
        STATUS: 'A',
        COD_CENTRO: null
      },
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: '',
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] }
  },

  watch: {
    'registro.QUANT_AJUSTE'() {
      this.calcularDiferenca()
    },
    'registro.QUANT_PECAS_AJUSTE'() {
      this.calcularDiferencaPecas()
    },
    'registro.COD_CENTRO'() {
      // Quando o centro de estoque for selecionado e já houver produto, carregar estoque
      if (this.registro.COD_PRO && this.registro.COD_CENTRO && !this.registro.CONTADOR) {
        this.carregarEstoqueProduto()
      }
    }
  },

  methods: {
    voltar() {
      this.$router.push('/estoque/ajuste')
    },

    getUsuarioLogado() {
      return window.localStorage.getItem('login') || 'Sistema'
    },

    async onProdutoSelected(produtoId) {
      this.registro.COD_PRO = produtoId
      
      if (produtoId && this.registro.COD_CENTRO) {
        await this.carregarEstoqueProduto()
      }
    },

    async carregarEstoqueProduto() {
      if (!this.registro.COD_PRO || !this.registro.COD_CENTRO) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const response = await this.$http.get(`/api/protected/estoque/getByProdutoIdCentroEstoqueId/${this.registro.COD_PRO}/${this.registro.COD_CENTRO}`)

        if (response.data && response.data.length > 0) {
          const estoque = response.data[0]
          this.estoqueProduto = {
            ...estoque,
            QUANT_PECAS: estoque.PECAS // Mapear PECAS para QUANT_PECAS
          }
          this.registro.DESCRICAO = this.estoqueProduto.DESCRICAO || this.estoqueProduto.NOME || ''
          this.registro.QUANT = this.estoqueProduto.QUANT || 0
          this.registro.QUANT_PECAS = this.estoqueProduto.PECAS || 0
          
          // Se estiver criando um novo registro, inicializar com valores atuais
          if (!this.registro.CONTADOR) {
            this.registro.QUANT_AJUSTE = this.registro.QUANT
            this.registro.QUANT_PECAS_AJUSTE = this.registro.QUANT_PECAS
          }
        }

      } catch (err) {
        console.error('Erro ao carregar estoque do produto:', err)
        this.$bvToast.toast('Erro ao carregar dados do estoque', { variant: 'warning' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    calcularDiferenca() {
      const quantAntes = parseFloat(this.registro.QUANT) || 0
      const quantDepois = parseFloat(this.registro.QUANT_AJUSTE) || 0
      this.registro.DIFE_QUANT = quantDepois - quantAntes
    },

    calcularDiferencaPecas() {
      const pecasAntes = parseFloat(this.registro.QUANT_PECAS) || 0
      const pecasDepois = parseFloat(this.registro.QUANT_PECAS_AJUSTE) || 0
      this.registro.DIFE_PECAS = pecasDepois - pecasAntes
    },
    
    async carregar(id) {
       this.$store.commit('controle/setAguardando', true)
       try {
           const response = await this.$http.get(`/api/protected/estoque/ajuste/getById/${id}`)
           
           if (Array.isArray(response.data) && response.data.length > 0) {
              const item = response.data[0]
              this.registro = { ...this.registro, ...item }
              
              // Carregar dados do estoque atual
              await this.carregarEstoqueProduto()
              
              // Recalcular diferenças
              this.calcularDiferenca()
              this.calcularDiferencaPecas()
           } else {
               this.$bvToast.toast('Registro não encontrado', { variant: 'warning' })
               this.voltar()
           }

       } catch (err) {
           console.error('Erro ao carregar', err)
           this.$bvToast.toast('Erro ao carregar dados', { variant: 'danger' })
       } finally {
            this.$store.commit('controle/setAguardando', false)
       }
    },

    async gravar() {
        // Validações
        if (!this.registro.COD_PRO) {
            this.$bvToast.toast('Informe o Produto', { variant: 'warning' })
            return
        }

        if (!this.registro.COD_CENTRO) {
            this.$bvToast.toast('Informe o Centro de Estoque', { variant: 'warning' })
            return
        }

        if (this.registro.QUANT_AJUSTE === null || this.registro.QUANT_AJUSTE === undefined) {
            this.$bvToast.toast('Informe a Quantidade Depois', { variant: 'warning' })
            if (this.$refs.edQuantAjuste) {
              this.$refs.edQuantAjuste.$el.focus()
            }
            return
        }

        if (this.registro.QUANT_PECAS_AJUSTE === null || this.registro.QUANT_PECAS_AJUSTE === undefined) {
            this.$bvToast.toast('Informe os Volumes Depois', { variant: 'warning' })
            return
        }

        try {
            const body = {
                registro: {
                  ...this.registro,
                  USUARIO: window.localStorage.getItem('login') || 'sistema'
                }
            }
            
            const isNovo = !this.registro.CONTADOR
            let url = '/api/protected/estoque/ajuste/post'
            if (!isNovo) {
                url = '/api/protected/estoque/ajuste/edit'
            }

            const res = await this.$http.post(url, body)

            // Captura o ID do registro salvo para selecionar na listagem
            let idSalvo = null
            
            if (isNovo) {
              // Para novos registros, tenta múltiplas possibilidades
              idSalvo = res.data?.CONTADOR || 
                       res.data?.contador || 
                       res.data?.insertId || 
                       res.data?.registro?.CONTADOR ||
                       res.data?.registro?.contador ||
                       null
            } else {
              idSalvo = this.registro.CONTADOR
            }
            
            if (idSalvo) {
              this.$store.commit('ajusteEstoque/SET_REGISTRO_SELECIONADO_ID', idSalvo)
            }
            this.$store.commit('ajusteEstoque/SET_RECARREGAR_LISTA', true)

            this.$bvToast.toast('Registro salvo com sucesso', { variant: 'success' })
            this.voltar()

        } catch (err) {
             console.error('Erro ao gravar', err)
             this.$bvToast.toast('Erro ao salvar registro', { variant: 'danger' })
        }
    },

    formatarNumero(valor) {
      if (!valor && valor !== 0) return '0,00'
      return Number(valor).toLocaleString('pt-BR', { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 })
    }
  },
  
  async created() {
      const id = this.$route.params.id
      if (id) {
          await this.carregar(id)
      }
  },
  
  mounted() {
      this.$nextTick(() => {
          // Focus no campo de produto
      })
  }

}
</script>

<style scoped>
.campo-desabilitado {
  background-color: #e9ecef !important;
  opacity: 0.7;
  cursor: not-allowed;
  pointer-events: none;
}

.modal-label-premium {
    font-size: 0.8rem;
    font-weight: 700;
    color: #6c757d;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 0.25rem;
}
</style>



// WEBPACK FOOTER //
// src/views/estoque/ajuste/AjusteEstoqueCadastro.vue